import { Limit, LimitType } from '@/api/profile';

export const CENTS_TO_DISABLE_ACTIONS = 0;

const checkLimitAmount = (
  limits: Limit[],
  currency: string,
  limitType: LimitType
) => {
  return limits.some(({ type, accounts }) => {
    if (type !== limitType) return;
    const account = accounts.find((acc) => acc.currency === currency);
    if (!account) return;
    const { amountCents, currentValueAmountCents } = account;
    return !(amountCents + currentValueAmountCents);
  });
};

export const isLimitReached = (limits: Limit[], currency: string) => {
  const isCoolingOff = limits.some(({ type }) => type === LimitType.CoolingOff);
  const isLoss = checkLimitAmount(limits, currency, LimitType.Loss);
  const isWager = checkLimitAmount(limits, currency, LimitType.Wager);
  return isCoolingOff || isLoss || isWager;
};
